import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import Navigation from './Navigation';
import TypeIt from "typeit-react";
import Home from './pages/Home';
import MRPView from './pages/MRPView';

function App() {
  return (
    <Router>
    <div>
      <div className="">
       
        <Switch>
          <Route exact path="/">
            <Home/>
          </Route>
         
        </Switch>

       

      </div>
    </div>
  </Router>
  );
}

export default App;
